var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('navbar'),_c('router-view'),(_vm.modal.showing)?_c('invite-users',{attrs:{"name":"header-invite-users"}}):_vm._e(),_c('footer-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }